require('../../modules/es6.math.acosh');
module.exports = require('../../modules/_core').Math.acosh;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/acosh.js
// module id = 1418
// module chunks = 2